export const VossPeriodKind = {
    FixedTime: 0,
    AlignedToBindingPeriod: 1,
    AlignedToSubscriptionBillingPeriod: 2
}

export const VossPeriodKindText = {
    [VossPeriodKind.FixedTime]: 'vossperiodkind.fixedtime',
    [VossPeriodKind.AlignedToBindingPeriod]: 'vossperiodkind.alignedtobindingperiod',
    [VossPeriodKind.AlignedToSubscriptionBillingPeriod]: 'vossperiodkind.alignedtosubscriptionbillingperiod'
}